import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Map } from 'immutable'
import compose from 'recompose/compose'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import { getBoundActions } from 'actions'
import EmailCapture from 'components/EmailCapture'
import { connect as connectStaticText } from 'components/StaticText/connect'

function renderEmailCapture (props, testClass) {
  const {
    emailSignup, doEmailSignup, staticText,
  } = props
  const submitFooterEmailDataLayer = true

  return (
    <EmailCapture
      buttonText={staticText.getIn(['data', 'formButtonText'])}
      inputPlaceholder={staticText.getIn(['data', 'formPlaceHolder'])}
      className={['footer-email-capture__email-capture', testClass]}
      submitFooterEmailDataLayer={submitFooterEmailDataLayer}
      success={emailSignup.get('success')}
      formName="footerEmailCapture"
      onFormSubmit={doEmailSignup}
      siteSegment={Map()}
      uiLocation="Footer"
    />
  )
}

class FooterEmailCapture extends Component {
  render () {
    const { props } = this
    const { staticText, isAnonymous } = props
    if (isAnonymous) {
      return (
        <div className="footer-email-capture">
          <div className="footer-email-capture__content">
            <div className="footer-email-capture__intro-text">
              { staticText.getIn(['data', 'title']) }
            </div>
            { renderEmailCapture(props) }
          </div>
        </div>
      )
    }
    return null
  }
}

FooterEmailCapture.propTypes = {
  doEmailSignup: PropTypes.func.isRequired,
  emailSignup: ImmutablePropTypes.map.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
}

export default compose(
  connect(
    (state) => ({
      emailSignup: state.emailSignup,
      isAnonymous: !state.auth.get('jwt'),
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        doEmailSignup: actions.emailSignup.doEmailSignup,
      }
    },
  ),
  connectStaticText({ storeKey: 'footerEmailCapture' }),
)(FooterEmailCapture)
